module.exports = __webpack_public_path__ + "languages/de_DE.po";